// extracted by mini-css-extract-plugin
export var cardIcon = "_7o-5";
export var cardIconUnframed = "_7o-9";
export var checkboxCard = "_7o-0";
export var checkboxCardSelected = "_7o-4";
export var disabled = "_7o-2";
export var interactive = "_7o-1";
export var outerBorder = "_7o-3";
export var spacerMedium = "_7o-8";
export var spacerSmall = "_7o-7";
export var spacerXsmall = "_7o-6";